<template>
  <div class="opera-fangXQ">
    <topNav :title="$t('fangXQ_title')"
            url="/opera/fangQ"></topNav>
    <datepik @change='dateChange' ref="datepik" limit="next" step="1"></datepik>
    <div class="formTop" :class='{formTopFix:formPosition==true}'>
      <div class="topOne" style="width:20%">{{$t('fangXQ_rmtype')}}</div>
      <div class="topOne" style="width:15%">{{$t('fangXQ_total_num')}}</div>
      <div class="topOne" style="width:15%">{{$t('fangXQ_available')}}</div>
      <div class="topOne" style="width:15%">{{$t('fangXQ_takeup')}}</div>
      <div class="topOne" style="width:15%">{{$t('fangQ_maintenance')}}</div>
      <div class="topOne" style="width:20%">{{$t('fangQ_rents')}}</div>
    </div>
    <table class="conditionList" align='center' style="border-collapse:collapse;width: 100%;table-layout: fixed;">
      <tbody class="tbodyH">
      <tr>
        <th width="20%"></th>
        <th width="15%"></th>
        <th width="15%"></th>
        <th width="15%"></th>
        <th width="15%"></th>
        <th width="20%"></th>
      </tr>
      <tr v-for='(item,index) in condition_list' :style="{background:item.roomTypeCode=='0000'?'#F7EF8C':''}" :key="index">
        <td v-if="item.roomTypeCode=='0000'">
         {{$t('fangTXQ_total')}}
        </td>
        <td v-else>
          {{item.roomType}}
        </td>
        <td>
          {{item.roomCount}}
        </td>
        <td>
          {{item.inLive}}
        </td>
        <td>
          {{item.inReservation}}
        </td>
        <td>
          {{item.inRemain}}
        </td>
        <!-- <td width="12.4%">
               {{item.avg}}
        </td> -->
        <td>
          {{item.rate}}
        </td>
      </tr>
      <tr style="width:100%;height:0.8rem;"></tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import moment from "moment";
  import datepik from "../operaCommon/datepik";

  export default {
    data() {
      return {
        condition_list: [],
        defaultDate: null,
        formPosition: false,
        bsum:false,
      };
    },
    mounted() {

      this.getData(this.$route.query.date);

      //监听该页面滚动条
      document
        .getElementsByClassName("opera-fangXQ")[0]
        .addEventListener("scroll", this.boxScroll);
    },
    methods: {
      //滚动条上拉下滑顶部固定事件
      boxScroll() {
        //console.log('监听')
        var pxScoll = document.getElementsByClassName("opera-fangXQ")[0].scrollTop;
        var tbodyHeight = document.getElementsByClassName('tbodyH')[0].clientHeight / 37.5;
        var viewTbodyHeight = document.getElementsByClassName('fangXQ')[0].clientHeight / 37.5;
        this.scrollTop = pxScoll / 37.5;
        if (tbodyHeight > viewTbodyHeight - 1) {
          if (this.scrollTop > 1.2) {
            this.formPosition = true;
          } else {
            this.formPosition = false;
          }
        } else {
          this.formPosition = false;
        }

      },
      //生命周期结束后自动执行销毁监听事件
      destroyed() {
        document
          .getElementsByClassName("opera-fangXQ")[0]
          .removeEventListener("scroll", this.boxScroll);
      },
      getData(time) {

        this.$http
          .post("/mobilepmsapi/opera/biz/getRoomSituationDetail ", {d: time})
          .then(res => {
            if (res.data.result == 0) {
              this.condition_list = res.data.retVal.list;
              this.$refs.datepik.setDateInit(res.data.retVal.d, time == null ? res.data.retVal.d : time);
            }
          });
      },
      dateChange(time) {

        this.getData(time);
      },
      //合计
      totalNum(option) {
        let sum = 0
        this.condition_list.forEach((item, index, arr) => {
          sum += item[option]
        })
        return sum
      },
      totalrate() {
        return (+this.totalNum('inReservation') - this.totalNum('inRemain')) / this.totalNum('roomCount')
      }

    },
    components: {
      datepik
    }
  };
</script>

<style lang='less'>
  .opera-fangXQ {
    overflow: auto;

    .formTop {
      width: 100%;
      clear: both;

      .topOne {
        height: 1.06666667rem;
        color: #fff;
        background-color: #f69c2d;
        text-align: center;
        line-height: 1.0133rem;
        float: left;
        font-size: 0.34666667rem;
        font-weight: bold;
        padding: 0;
      }
    }

    .formTopFix {
      position: fixed;
      top: 1.04rem;
      z-index: 200;
    }

    .conditionList {
      width: 100%;

      tr {
        background-color: #fff;
        font-size: 0.32rem;

        &:nth-of-type(2n-1) {
          background-color: #f5f5f5;
        }

        th {
          color: #fff;
          // height: 1.06666667rem;
          text-align: center;
          font-size: 0.34666667rem;
          background-color: #f69c2c;
          padding: 0;
        }

        td {
          // height: 1.06666667rem;
          padding: 0px;
          word-wrap: break-word;
          text-align: center;
          padding: 13px 0px;

          p {
            margin: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// fangXQ.vue?11ed18f8